module.exports = class ProvinceFormCtrl
  constructor: ($scope) ->
    'ngInject'
    @$scope = $scope

  submit: ->
    @onSubmit(province: @province)
